// extracted by mini-css-extract-plugin
export default {"mainScreen":"RegistrationMain_mainScreen__PzCs8"};